import 'moment-timezone';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { SplitButton } from 'primereact/splitbutton';
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from 'react-router-dom';
import { getEndpointUrl, getTimestamp } from "../../Utils/Common";
import CreateType from "./CreateType";
import UpdateType from "./UpdateType";
import ModalDeleteType from "./ModalDeleteType";
import { FaTrashAlt } from 'react-icons/fa';
import ModalDeleteTypeMultiple from './ModalDeleteTypeMultiple';

const TableType = () => {
    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const inputRef = useRef();
    const timeout = useRef();

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    const [selectAll, setSelectAll] = useState(false);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [types, setTypes] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [brands, setBrands] = useState([]);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 0
    });

    const [toggledClearRows, setToggleClearRows] = useState(false);

    const [showUpdate, setShowUpdate] = useState(false);
    const [updateData, setUpdateData] = useState({});

    const [showDelete, setShowDelete] = useState(false);
    const [deleteData, setDeleteData] = useState({});

    const [showDeleteMultiple, setShowDeleteMultiple] = useState(false);

    const [modalCreate, setModalCreate] = useState(false);

    const isSelectable = (data) => data.id != 0;

    const isRowSelectable = (event) => (event.data ? isSelectable(event.data) : true);

    const loadBrands = () => {
        fetch(getEndpointUrl() + `/v2/car_brand?page=0&per_page=100&v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setBrands(json.results.data);
            }
        });
    }

    const loadLazyData = () => {
        setLoading(true);

        let url = `/v2/car_type?page=${lazyParams.page}&per_page=${lazyParams.rows}&query=${globalFilterValue}`;
        if (selectedBrand) {
            url += `&brand_id=${selectedBrand}`;
        }
        url += `&v=${getTimestamp()}`;

        fetch(getEndpointUrl() + url, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setTotalRecords(json.results.total);
                setTypes(json.results.data);
            }
            setLoading(false);
        });
    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    useEffect(() => {
        loadBrands();
    }, []);

    useEffect(() => {
        return () => loadLazyData();
    }, [lazyParams, selectedBrand]);

    useEffect(() => {
        clearTimeout(timeout.current);

        if (!globalFilterValue.trim()) {
            loadLazyData()
            return
        }
        timeout.current = setTimeout(() => {
            loadLazyData();
        }, 600);
    }, [globalFilterValue]);

    const onGlobalFilterChange = (e) => {
        setLoading(true);
        lazyParams.page = 0;
        setTotalRecords(0);
        setTypes([]);

        const value = e.target.value;

        setGlobalFilterValue(value);
    };

    const onSelectionChange = (event) => {
        const value = event.value;
        setSelectedTypes(value);
        setSelectAll(value.length === totalRecords);
    }

    const header = (
        <Row>
            <Col md={4} sm={12} className="my-2">
                <h5 className="me-auto fw-bold pt-2">Master Data Tipe</h5>
            </Col>
            <Col md={5} sm={12} className="my-2">
                <div className="d-md-flex">
                    <div className="ms-auto">
                        {selectedTypes?.length ?
                            <Button key="delete" onClick={(e) => {
                                setShowDeleteMultiple(true);
                                setToggleClearRows(!toggledClearRows);
                            }} variant="danger" className="me-3"><FaTrashAlt /> ({selectedTypes.length}) Hapus yang terpilih</Button> : ''
                        }
                        <Link to={`#`} title="Input Tipe" onClick={(e) => setModalCreate(true)} className="btn btn-success me-3"><AiOutlinePlus className="me-2" /> Input Data</Link>
                        <CreateType brands={brands} onCallback={(e) => onCallback(e)} show={modalCreate} close={(e) => setModalCreate(false)} />
                    </div>
                </div>
            </Col>
            <Col md={3} sm={12} className="my-2">
                <div className="d-md-flex">
                    <div className="p-input-icon-left me-2" style={{ minWidth: '150px' }}>
                        <i className="pi pi-search" />
                        <InputText ref={inputRef} className="p-inputtext-sm" onChange={onGlobalFilterChange} placeholder="Pencarian..." style={{ minWidth: '100%' }} />
                    </div>
                    <div>
                        <select className="form-select form-select-sm" value={selectedBrand || ''} onChange={(e) => setSelectedBrand(e.target.value || null)}>
                            <option value="">Semua Merek</option>
                            {brands.map(brand => (
                                <option key={brand.id} value={brand.id}>{brand.companyName}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </Col>
        </Row>
    );

    const kelolaBodyTemplate = (rowData) => {
        return <SplitButton size="small" label="Edit" icon="pi pi-pencil"
            onClick={(e) => {
                setShowUpdate(true);
                setUpdateData(rowData);
            }}
            model={[
                {
                    label: 'Hapus',
                    icon: 'pi pi-trash',
                    disabled: userLogin.role != 'admin',
                    command: () => {
                        setShowDelete(true);
                        setDeleteData(rowData);
                    }
                }
            ]} severity="secondary" text />
    };

    const onCallback = useCallback((e) => {
        loadLazyData();
    }, []);

    return (
        <Container className="mt-3">
            <DataTable
                value={types}
                lazy
                size="small"
                responsiveLayout="scroll"
                dataKey="id"
                header={header}
                globalFilterFields={['typeName', 'brandName']}
                emptyMessage="Tidak ada data yang ditemukan."
                paginator
                first={lazyParams.first}
                rows={15}
                totalRecords={totalRecords}
                onPage={onPage}
                loading={loading}
                selection={selectedTypes}
                onSelectionChange={onSelectionChange}
                selectAll={selectAll}>
                <Column selectionMode="multiple" />
                <Column field="id" header="ID" />
                <Column field="typeName" header="NAMA TIPE" />
                <Column field="brandName" header="MEREK" />
                <Column field="brandOriginCountry" header="NEGARA ASAL" />
                <Column header="KELOLA" body={kelolaBodyTemplate} />
            </DataTable>
            <UpdateType row={updateData} brands={brands} onCallback={(e) => onCallback(e)} show={showUpdate} close={() => setShowUpdate(false)} />
            <ModalDeleteType row={deleteData} onCallback={(e) => onCallback(e)} show={showDelete} close={() => setShowDelete(false)} />
            <ModalDeleteTypeMultiple dataDelete={selectedTypes} onCallback={(e) => onCallback(e)} show={showDeleteMultiple} close={() => setShowDeleteMultiple(false)} />
        </Container>
    );
}

export default TableType;
